/**
 * NOTE: This module is going to be deprecated soon in favor of the new carts and checkout modules.
 * @deprecated
 */
import { TaxNumber } from '@monolith/legacy/types/tax-number';
import { Cart, CartTracking, Checkout, NeededInformations } from '@monolith/legacy/types/cart';
import actions from '@monolith/legacy/store/cart/actions';
import mutations from '@monolith/legacy/store/cart/mutations';
import getters from '@monolith/legacy/store/cart/getters';
import { BulkUpdate } from '@monolith/legacy/services/api/cart';
import { BrandDiscount } from '@monolith/legacy/types/api/brand-discount';
import { getCurrency } from '@modules/core/services/metas/currency';

export { CART_STORE_ID } from './constants';

export interface CartState {
  apiCallCount: number;
  bulkUpdates: BulkUpdate[];
  brandsDiscounts: {
    [index: string]: BrandDiscount;
  };
  businessValidationStep: NeededInformations;
  checkout: Checkout;
  carts?: Cart[];
  checkoutFormErrors: {
    recargo: string[];
    taxNumber: string[];
    companyId: boolean;
    eori: string[];
  };
  checkoutFormSuccess: {
    eori: boolean;
  };
  eori: string;
  isCartButtonLoading: boolean;
  isCartLoading: boolean;
  isTotalsLoading: boolean;
  itemsCounts: {
    main: number;
    savedForLater: number;
  };
  isSavedForLaterDisplayed?: boolean;
  lastPromocodeCallResult: {
    code: string;
    errorMessage: string;
  };
  recargoEnabled: boolean;
  savedForLater?: Cart[];
  taxNumber: TaxNumber;
  tracking: CartTracking;
}

const createInitialState = () => {
  const initialState: CartState = {
    checkout: {
      type: 'checkout',
      id: null,
      status: 'unsubmitted',
      billing_items: [],
      retailer_grand_total_amount_with_vat: {
        amount: 0,
        currency: getCurrency(),
      },
      total_amount_with_vat: {
        amount: 0,
        currency: getCurrency(),
      },
      total_amount_vat: {
        amount: 0,
        currency: getCurrency(),
      },
      total_amount: { amount: 0, currency: getCurrency() },
      free_shipping_minimum_amount: {
        amount: 30000,
        currency: getCurrency(),
      },
      amount_left_for_free_shipping: {
        amount: 30000,
        currency: getCurrency(),
      },
      free_shipping: false,
      regular_shipping_fees_amount: {
        amount: 2000,
        currency: getCurrency(),
      },
      carts: [],
      firstInit: true,
      is_first_checkout: false,
      extra_taxes: {
        recargo_de_equivalencia: null,
      },
    },
    apiCallCount: 0,
    tracking: {
      minimumReachedEventsSent: [],
    },
    businessValidationStep: NeededInformations.None,
    taxNumber: {
      type: null,
      value: '',
      isSkipped: false,
      isValid: false,
    },
    isCartButtonLoading: false,
    checkoutFormErrors: {
      recargo: [],
      taxNumber: [],
      companyId: false,
      eori: [],
    },
    checkoutFormSuccess: {
      eori: false,
    },
    isCartLoading: false,
    bulkUpdates: [],
    isTotalsLoading: true,
    recargoEnabled: null,
    eori: '',
    lastPromocodeCallResult: {
      code: '',
      errorMessage: '',
    },
    brandsDiscounts: {},
    itemsCounts: {
      main: 0,
      savedForLater: 0,
    },
    savedForLater: [],
    isSavedForLaterDisplayed: false,
  };

  return initialState;
};

export default {
  namespaced: true,
  state: createInitialState(),
  actions,
  mutations,
  getters,
};
